import { MinorIdmissionIDValidation } from './MinorIdmissionIDValidation';

export function VerifyMinorIDPage() {
  return <MinorIdmissionIDValidation />;
}

export default VerifyMinorIDPage;
